<div class="pages-body flex flex-column cust-height">
    <div class="align-self-center mt-cust mb-auto" style="width: 350px;">
        <div class="pages-panel card flex flex-column">                   
            <div class="col-12 text-center">
                <img src="../../../assets/layout/images/documalis_logo.png">
            </div>
            <div class="col-12 text-center">
                <span>{{'Error_Page' | translate}}</span>
            </div>
        </div>
    </div>
</div>